import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Departments extends AbstractController {
    protected controllerName = 'Departments';
}
